import {makeAutoObservable} from "mobx";
import {
    kpiRepositoryStore, KpiShippingLoadParams, kpiShippingReceiptExitStore,
    kpiShippingRecordReceiptExitStore, kpiWeighingDashboardStore
} from "./kpi";
import {kpiReceiptStore} from "./kpi/KpiReceiptStore";

class DashboardStore {
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }

    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }

    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }

    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }

    private _fromRelative?: string
    private _toRelative?: string
    private _fromAbsolute?: string
    private _toAbsolute?: string
    private _customerId?: string

    constructor() {
        makeAutoObservable(this)
    }

    async load(onlyOnActiveCustomerId?: string) {
        const {
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
        } = this
        const query = {
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
        }

        if (
            !onlyOnActiveCustomerId ||
            !customerId ||
            onlyOnActiveCustomerId === customerId
        ) {
            await Promise.all([
                this.loadRepository(query),
                this.loadReceipts(query),
                this.loadWeighing(query),
                this.loadShippingRecordReceiptExist(query),
                this.loadShippingReceiptExist(query)
            ])
        }
    }

    private async loadShippingReceiptExist(query: KpiShippingLoadParams) {
        await kpiShippingReceiptExitStore.load(query)
    }

    private async loadShippingRecordReceiptExist(query: KpiShippingLoadParams) {
        await kpiShippingRecordReceiptExitStore.load(query)
    }

    private async loadWeighing(query: KpiShippingLoadParams) {
        await kpiWeighingDashboardStore.load(query)
    }

    private async loadReceipts(query: KpiShippingLoadParams) {
        await kpiReceiptStore.loadReceipts(query)
    }

    private async loadRepository(query: KpiShippingLoadParams) {
        await kpiRepositoryStore.load(query)
    }
}

const dashboardStore = new DashboardStore()

export {
    dashboardStore
}
